import { render } from "./ModaleQuiz.vue?vue&type=template&id=43bd3719&scoped=true"
import script from "./ModaleQuiz.vue?vue&type=script&lang=js"
export * from "./ModaleQuiz.vue?vue&type=script&lang=js"

import "./ModaleQuiz.vue?vue&type=style&index=0&id=43bd3719&scoped=true&lang=css"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43bd3719"]])

export default __exports__